import {
  AppBar,
  Button,
  Divider,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { AuthContext } from "../Auth/AuthContextProvider";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    zIndex: theme.zIndex.drawer + 1,
  },
  fillElement: {
    flexGrow: 1,
  },
  unclickableMenuTitle: {
    opacity: 0.9,
    fontWeight: 500,
  },
  navLink: {
    color: theme.palette.primary.contrastText,
    padding: "2px 4px",
    borderRadius: "4px",
    "&:focus": {
      outline: "none",
    },
    "&:focus-visible": {
      outline: "2px solid #FFFFFF",
      outlineOffset: "2px",
    },
  },
  contrastFocusRing: {
    borderRadius: "50%",
    "&:focus": {
      outline: "none",
    },
    "&:focus-visible": {
      outline: "2px solid #FFFFFF !important",
      outlineOffset: "-6px",
    },
  },
}));

export default function TopNav() {
  const classes = useStyles();
  const authContext = React.useContext(AuthContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const routeHistory = useHistory();

  function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }
  return (
    <>
      <AppBar elevation={4} position="fixed" className={classes.root}>
        <Toolbar>
          <Button component={Link} color="inherit" to="/" className={classes.navLink}>
            <Typography variant="h1">Utah Adoption Registry</Typography>
          </Button>
          <span className={classes.fillElement}></span>
          {authContext.isLoggedIn && (
            <div>
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                aria-expanded={open ? "true" : "false"}
                onClick={handleMenu}
                color="inherit"
                className={classes.contrastFocusRing}
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem style={{ opacity: 0.9, fontWeight: 500 }} disabled tabIndex={-1} role={"presentation"}>
                  {authContext.userInfo.contactInformation.firstName +
                    " " +
                    authContext.userInfo.contactInformation.lastName}
                </MenuItem>
                {authContext.userInfo.administrator && (
                  <MenuItem onClick={handleClose} component={Link} to="/admin">
                    Admin
                  </MenuItem>
                )}
                {authContext.userInfo.administrator && <Divider />}
                <MenuItem onClick={handleClose} component={Link} to="/my-registrations">
                  My Registrations
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleClose} component={Link} to="/profile">
                  Profile
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={() => {
                    routeHistory.push("/");
                    authContext.logout();
                    handleClose();
                  }}
                >
                  Log Out
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
      {/* This Toolbar just adds vertical spacing so no content is hidden  */}
      <Toolbar />
    </>
  );
}
